import React, { useCallback, useMemo } from 'react';
import { Progress, Table } from 'antd';
import { Icons } from 'icons';

import { classnames } from 'lib/classnames';
import useI18n from 'lib/hooks/useI18n';

import ItemRow from '../ItemRow';
import { OperateRes } from '../type';

import styles from '../index.module.less';

const cx = classnames(styles);
interface ResultTableProps {
  data: OperateRes[];
  results: OperateRes[];
}

const ResultTable: React.VFC<ResultTableProps> = ({ data, results }) => {
  const { t } = useI18n();

  // 当前进度
  const percent = useMemo(() => {
    return Math.trunc(((results?.length || 0) / (data?.length || 0)) * 100);
  }, [data?.length, results?.length]);

  // 是否结束
  const isFinish = useMemo(() => {
    return (results?.length && results?.length === data?.length) || '';
  }, [data?.length, results?.length]);

  const operateTip = useMemo(() => {
    if (isFinish) {
      return t('pages.itemsBatchOperate.default.operateComplete', { value: data?.length });
    } else {
      return t('pages.itemsBatchOperate.default.operateProgress', {
        current: (results?.length || 0) + 1,
        num: data?.length,
      });
    }
  }, [data?.length, isFinish, results?.length, t]);

  // TODO: 状态流转用updateItem的逻辑，容易触发redis锁报错，待updadteItem方法调整后需要去掉这个判断
  const isRedisLockTip = useCallback(
    (tip: string) => {
      return tip === t('pages.itemsBatchOperate.columns.ResultTable');
    },
    [t],
  );
  const columns = [
    {
      title: t('global.item'), // 'Key',
      key: 'key',
      dataIndex: 'key',
      width: '50%',
      render: (cellData: string, rowData: OperateRes) => <ItemRow item={rowData as any} />,
    },
    {
      title: t('pages.itemsBatchOperate.columns.result'),
      key: 'status',
      dataIndex: 'status',
      render: (cellData: string, rowData: OperateRes) => {
        const targetCell = results?.find(i => i.key === rowData?.key);
        if (!targetCell) return <></>;
        if (isRedisLockTip(targetCell?.message) || targetCell?.status === 'success') {
          return (
            <div className={cx('batch-result-column')}>
              <Icons.Alert_Success className={cx('batch-result-icon')} />
              <span className={cx('batch-result-column-text', 'success')}>{t('global.success')}</span>
            </div>
          );
        } else {
          return (
            <div className={cx('batch-result-column')}>
              <Icons.Alert_Error className={cx('batch-result-icon')} />
              <span className={cx('batch-result-column-text', 'error')}>
                {`${t('global.fail')}：${targetCell?.message || t('libs.error.default.errorData')}`}
              </span>
            </div>
          );
        }
      },
    },
  ];

  return (
    <>
      <Progress percent={percent} size={['100%', 12]} />
      <p className={cx('batch-operate-confirm-header-tip')}>{operateTip}</p>
      {isFinish && (
        <Table
          className={cx('batch-operate-confirm-wrap')}
          dataSource={data}
          rowKey="key"
          columns={columns}
          pagination={false}
        />
      )}
    </>
  );
};

export default ResultTable;
